import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Mascot from "@/components/Mascot";
import { api } from "@/lib/api";

export default function Welcome() {
  const [resumeId, setResumeId] = useState(null);
  const [me, setMe] = useState(null); // { authenticated, parent? }

  useEffect(() => {
    try {
      const id = localStorage.getItem("mlou_journey_id");
      if (id) setResumeId(id);
    } catch (_) {}

    api.me().then(setMe).catch(() => setMe({ authenticated: false }));
  }, []);

  return (
    <main className="relative mx-auto flex min-h-screen max-w-md flex-col items-center justify-center px-6 py-12 text-center">
      <div className="absolute -top-10 -left-10 h-48 w-48 rounded-full bg-[#ffd9b3] opacity-40 blur-3xl" />
      <div className="absolute -bottom-16 -right-12 h-56 w-56 rounded-full bg-[#c8b6ff] opacity-40 blur-3xl" />

      <div className="relative z-10 flex flex-col items-center gap-8">
        <div className="flex items-end justify-center gap-2">
          <Mascot character="neo" size={88} />
          <span aria-hidden className="pb-6 text-3xl">✨</span>
          <Mascot character="lyria" size={88} />
        </div>

        <div className="space-y-3">
          <h1 className="font-[Fredoka] text-4xl font-semibold text-[#3b2a4a]">
            Mamoune & Loulou
          </h1>
          {me?.authenticated ? (
            <p className="text-base leading-relaxed text-[#5b4b6b]">
              Bon retour <strong>{me.parent.display_name}</strong> ! Prêt à lancer
              une matinée magique ?
            </p>
          ) : (
            <p className="text-base leading-relaxed text-[#5b4b6b]">
              Bienvenue dans le monde de <strong>Neo</strong> et <strong>Lyria</strong>.
              Ensemble, transformons la journée de votre enfant en une douce aventure.
            </p>
          )}
        </div>

        <div className="grid w-full gap-3 rounded-3xl bg-white/70 p-5 text-left shadow-sm backdrop-blur">
          <p className="text-sm font-medium text-[#3b2a4a]">
            ✨ Des missions magiques, hors écran
          </p>
          <p className="text-sm font-medium text-[#3b2a4a]">
            🌿 Des routines apaisées et structurées
          </p>
          <p className="text-sm font-medium text-[#3b2a4a]">
            💛 Une charge mentale allégée pour vous
          </p>
        </div>

        {me?.authenticated ? (
          <div className="flex w-full flex-col gap-3">
            {resumeId && (
              <Link to={`/journey/${resumeId}`} className="w-full">
                <Button
                  size="lg"
                  className="w-full rounded-full bg-[#ff8a65] py-6 text-base font-semibold text-white shadow-lg hover:bg-[#ff7043]"
                >
                  Reprendre la matinée
                </Button>
              </Link>
            )}
            <Link to="/setup" className="w-full">
              <Button
                size="lg"
                className={`w-full rounded-full ${
                  resumeId ? "bg-white/70 text-[#3b2a4a] hover:bg-white" : "bg-[#ff8a65] text-white hover:bg-[#ff7043]"
                } py-6 text-base font-semibold shadow-lg`}
              >
                {resumeId ? "Commencer une nouvelle aventure" : "Lancer la matinée"}
              </Button>
            </Link>
            <a href="/parent" className="text-xs text-[#7a6b8a] hover:text-[#ff7043]">
              → Mon espace parent
            </a>
          </div>
        ) : (
          <div className="flex w-full flex-col gap-3">
            <a href="/parent/register" className="w-full">
              <Button
                size="lg"
                className="w-full rounded-full bg-[#ff8a65] py-6 text-base font-semibold text-white shadow-lg hover:bg-[#ff7043]"
              >
                Créer mon compte parent
              </Button>
            </a>
            <a href="/parent/login" className="w-full">
              <Button
                size="lg"
                variant="ghost"
                className="w-full rounded-full bg-white/70 py-6 text-base font-medium text-[#3b2a4a] hover:bg-white"
              >
                J'ai déjà un compte
              </Button>
            </a>
            <Link to="/setup" className="mt-1 text-xs text-[#7a6b8a] hover:text-[#ff7043]">
              Tester sans s'inscrire →
            </Link>
          </div>
        )}

        <p className="text-xs text-[#7a6b8a]">
          Version gratuite · Matinée magique jusqu'au déjeuner
        </p>
      </div>
    </main>
  );
}
